//package import 
import React, { useEffect, useState } from "react";
import { Pie } from 'react-chartjs-2';
import { useRouteMatch, useHistory } from "react-router-dom";

//component import 
import noSharesImage from "../../assests/images/myShares/noShares.webp"
import shareFlowImage from "../../assests/images/dashboardImages/dashboardShareIcon1.webp"
import { getShareDetials,getVerificationStatus,getVerificationOTP ,UserDetails} from "../../services/apiServices/GetServices";
import { ValidateEmail,userDetailsApi } from "../../services/apiServices/PostServices";
import { showToast } from "../../utils/constants/Toaster";
import { OtpSentTextMobileNumber,OtpSentTextMessageEmail,EmailVerificationPendingMessage,NumberVerificationPendingMessage } from "../../utils/TextInputUtils";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import Loader from "../loadingScreens/Loader";
import OtpInput from 'react-otp-input';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'

const MyShares = () => {

  const history = useHistory();
  const [show, setShow] = useState(false);
  const [file, setFile] = useState("")
  const handleClose = () => setShow(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [shareDetails, setShareDetails] = useState([])
  const [historyRequest, setHistoryRequest] = useState([])
  const [disableButton, setDIsabledButton] = useState(false)
  const [isLoader, setIsLoader] = useState(false)
  const [errorMessage,setErrorMessage]=useState("")
  const initialTime = 2 * 60 * 1000;
  const [time, setTime] = useState(initialTime) 
  const [verificationStatus,setVerificationStatus]=useState()
  const [otp, setOtp] = useState('');

  useEffect(() => {
    let timer;
    if (isModalOpen) {
      // Start the timer when the modal is open
      timer = setInterval(() => {
        setTime(prevTime => {
          if (prevTime <= 0) {
            // Stop the timer if time is up
            clearInterval(timer);
            return 0;
          }
          return prevTime - 1000; // Decrease by 1000 milliseconds (1 second)
        });
      }, 1000);
    } else {
      // Clear the timer if the modal is closed
      clearInterval(timer);
    }

    // Cleanup the interval when the component unmounts or `isModalOpen` changes
    return () => clearInterval(timer);
  }, [isModalOpen,time]); // Dependency array includes `isModalOpen`
 

  useEffect(() => {
    callShareDetailsApi()
    callVerificationStatusApi()
    handleUSerDetailsApi()
  }, [])


  //function call to handle userDetails
  const handleUSerDetailsApi = async() => {
    try{
      const res = await UserDetails(`user`);
      if (res?.success) {
          const reqbody = {
            id: res?.data[0]?.id
        }
        if(res?.data[0]?.id!== ""){
          const res = await userDetailsApi(`userDetails`, reqbody);
          if (res?.success) {
            if(res?.share_history !== null){
              setHistoryRequest(res?.share_history)
            }else{
              setHistoryRequest([])
            }
        } else {
            // showToast(3, res?.message)
            console.log("res", res?.message)
        }
        }
       
      }else{
          console.log("res",res?.message)
         // showToast(3,res?.message)
      }
    }catch(error){
      console.log("error",error)
    }
    
}

  const addOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return day + 'th';
    }

    switch (day % 10) {
      case 1:
        return day + 'st';
      case 2:
        return day + 'nd';
      case 3:
        return day + 'rd';
      default:
        return day + 'th';
    }
  }

  const formatTime = (timeInMilliseconds) => {
    const minutes = Math.floor(timeInMilliseconds / (60 * 1000));
  const seconds = Math.floor((timeInMilliseconds % (60 * 1000)) / 1000);
  const formatSeconds = seconds < 10 ? `0${seconds}` : seconds
  return `0${minutes}:${formatSeconds}`;
  };

  const handleFormatedDate = (date) => {
    const originalDate = new Date(date); // Replace this with your date object

    const options = {
      weekday: 'short',  // Short weekday name (e.g., Wed)
      day: 'numeric',    // Numeric day of the month (e.g., 1)
      month: 'short',    // Short month name (e.g., Jan)
    };

    const formattedDate = originalDate.toLocaleDateString('en-US', options);
    const dayWithOrdinal = addOrdinalSuffix(originalDate.getDate());
    const finalFormattedDate = formattedDate.replace(originalDate.getDate(), dayWithOrdinal);
    return finalFormattedDate
  }

  //function to call list api
  const callShareDetailsApi = async () => {
    // setIsLoader(true)
    try {
      const res = await getShareDetials("shares")

      if (res?.success) {
        if (res?.message !== "No shares available") {
          setShareDetails(res?.data[0])
          // setHistoryRequest(res?.data[0]?.details)
        } else {
          setShareDetails([])
          // setHistoryRequest([])
        }
      } else {
        console.log("res", res?.message)
      }
    } catch (error) {
      console.log("error", error)
    }

  }

  const callVerificationStatusApi = async () => {
    try {
      const res = await getVerificationStatus("verificationStatus")

      if (res?.success) {
        setVerificationStatus(res?.verification_status)
      } else {
        console.log("res", res?.message)
      }
    } catch (error) {
      console.log("error", error)
    }

  }

  //function call to open modal
  const handleShow = (value) => {
    setFile(value)
    setShow(true);
  }

  const PieChart = () => {
    // Sample data for the pie chart
    const data = {
      height: [200],
      labels: ['Shares Got', 'Shares Sold'],
      datasets: [
        {
          data: [shareDetails?.length !== 0 ? shareDetails?.total_shares_purchased : 0, shareDetails?.length !== 0 ? shareDetails?.total_shares_sold : 0],
          backgroundColor: ['#D3E4F5', '#B7C5F9'],
          hoverBackgroundColor: ['#D3E4F5', '#B7C5F9'],
        },
      ],
    };

    const options = {
      plugins: {
        legend: {
          display: true,
          position: 'right',
          labels: {
            boxWidth: 15,
            // fontColor: 'black',
          },
        },
      },
    };

    return (
      <div style={{ width: "250px" }}>
        {/* <h4>Share Details</h4> */}
        <Pie data={data} options={options} />
      </div>
    );
  };

  const handleClickHere = () => {
    history.push("/customerPortal/myShares/buyShares")
  }
  const handleCloseModal = () => {
    setIsModalOpen(false)
    setTime(initialTime)
    setOtp("")
  }

  const handleVerification = async () => {
    try{

      if (otp === "") {
        setErrorMessage("Please enter OTP")
       
      }else if(otp.length != 4){
        setErrorMessage("Please enter valid OTP!")
      } 
      else {
        setErrorMessage("")
        const reqbody = {
          type: verificationStatus?.type,
          otp: otp
      }
      const message = verificationStatus?.type === 'email' ? 'Your mail is verified' : 'Your mobile number is verified'
      const res = await ValidateEmail("validateVerification", reqbody);
      if (res?.success) {
        setDIsabledButton(true)
        callVerificationStatusApi()
          setIsModalOpen(false)
          setOtp("")
    
          showToast(1, message)
      } else {
          showToast(3, res?.message)
          console.log("res",res)
      }
      }

        
    }catch(error){
        console.log("error",error)
    }
}

const callApiToSendOtp = async(type) => {
  const apiEndPoint = type === 'email' ? 'verificationOTP/email' : 'verificationOTP/phone'
  const res = await getVerificationOTP(apiEndPoint)
  if(res?.success){
    showToast(1,res?.message)
  }else{
    console.log("res",res?.message)
  }
}
  const handleOpenModalVerify = async(type) => {
    await callApiToSendOtp(type)
    setIsModalOpen(true)
  }

  const handleResend = async(type) => {
    await callApiToSendOtp(type)
    setTime(initialTime)
  } 

  return (
    <div className="col-md-12 d-flex flex-column full-height  " >
      {isLoader ? <Loader /> : null}
      <h1 className="fs-4 w-100 border-bottom border-top p-2 ">
        Shares
      </h1>
      {
         verificationStatus?.is_verification_pending ? 
        <div className="d-flex justify-content-between warningBoxWidth my-1">
        <div className="col-md-12  mx-3 p-1 d-flex flex-column justify-content-center align-items-center text-center borderOrange ">
          <h5 className="colorOrange fw-bold m-0">{verificationStatus?.type === "email" ? EmailVerificationPendingMessage:NumberVerificationPendingMessage }</h5>
          <button type="button" onClick={() => handleOpenModalVerify(verificationStatus?.type)} className="colorOutlineBlue my-2"> Click here</button>
        </div>
      </div> :
      null
      }
      {
        shareDetails.length !== 0 ?
          <div className="sub-height" >
            <div className="d-flex flex-row justify-content-around  px-4">
              <div className="col-lg-3 d-flex flex-column text-center boxBackgroundStyle border rounded h-25 pb-4">
                <h2 className="colorPrimary fs-2 fw-bold">Current Shares</h2>
                <h2 className="colorPrimary fs-2 fw-bold">{shareDetails?.current_share !== null ? shareDetails?.current_share : 0} </h2>
                <div className="align-self-end">
                  <img src={shareFlowImage} alt="total-shares" />
                </div>
              </div>
              <div className="col-lg-3 d-flex flex-column text-center boxBackgroundStyle border rounded h-25 pb-4">
                <h2 className="colorPrimary fs-2 fw-bold">My Investments</h2>
                <h2 className="colorPrimary fs-2 fw-bold">₹{shareDetails?.investment !== null ? shareDetails?.investment : 0}</h2>
                <div className="align-self-end">
                  <img src={shareFlowImage} alt="total-shares" />
                </div>
              </div>

              <div className="col-lg-3 d-flex flex-column justify-content-center  border rounded h-25">
                <div className="mx-4" >
                  <p className="m-0 fw-bold fs-5" ><span className="roboto">Share Details</span> </p>
                </div>
                <div>
                  {
                    shareDetails?.total_shares_purchased === null && shareDetails?.total_shares_sold === null ?
                      <div className="pieSize  d-flex  justify-content-center align-items-center ">
                        <h6>No Shares Found</h6>
                      </div>
                      :
                      <div className="pieSize">
                        <PieChart />
                      </div>
                  }
                </div>

              </div>

            </div>

            <CustomModal
              close={handleClose}
              open={show}
              imgvalue={file}
            />

            <div className="">
              <div className="d-flexflex-column border shadow border-1 m-2">
                <h5 className="sharesBackground p-3">Share Allocation Status</h5>
                <div className="px-5">
                  {historyRequest.map((item, index) => (
                    <div className="p-2" key={index}>

                      <div className="d-flex flex-row justify-content-between">
                        <h6 className="colorPrimary w-25 m-0">{item?.buy_amount !== 0 ? "Form submission-purchase" : "Form submitted -sell "}</h6>
                        <div className="d-flex flex-column w-25">
                          <h6 className={item?.approved !== null ? "colorPrimary text-center ms-xxl-1 m-0" : "status-pending text-center m-0"}>{item?.approved !== null ? "Admin approved" : item?.approved === null && item?.cancel_reason !== null ? "" : "Pending for approval"}</h6>
                          {item?.approved !== null ? <p className="previewColor cursorPointer text-center ms-xxl-1  m-0" onClick={() => handleShow(item?.image_url)}>{"Preview Image"}</p> : ""}
                        </div>
                        <div className="w-25">

                          {
                            item?.approved === null && item?.cancel_reason !== null ?
                              <h6 className={"colorPrimary text-end"}>{"Shares Request Rejected"}</h6> :
                              <div className="d-flex flex-column">
                                <h6 className={item?.approved !== null ? "colorPrimary  text-end m-0" : "status-pending text-end m-0"}> {item?.buy_amount !== 0 ? `${item?.share_name} allocated` : `${item?.share_name} deducted`}</h6>
                                {
                                  item?.approved !== null ?
                                    <div className="d-flex justify-content-end">
                                      <h6 className="fs-6 m-0" style={item?.buy_amount !== 0 ? { color: '#0A6D26' } : { color: '#FF2C3C' }}> {item?.buy_amount !== 0 ? `+${item.buy_shares}` : `-${item.sell_shares}`} Shares</h6>
                                    </div>
                                    : null
                                }
                              </div>
                          }
                        </div>
                      </div>
                      <div>
                      </div>

                      <div className="d-flex flex-row justify-content-between align-items-center align-content-center">
                        <div className="d-flex justify-content-center align-items-center">   <span className={item.created !== null ? "big-dot" : "dot"}></span></div>
                        <hr className="flex-fill track-line" />
                        {
                          item?.approved === null && item?.cancel_reason !== null ?
                            <div className="d-flex justify-content-center align-items-center"> <span className={"big-dot"}></span> </div> :
                            <div> <span className={item?.approved !== null ? "big-dot" : "dot"}></span></div>
                        }
                        {
                          item?.approved === null && item?.cancel_reason !== null ?
                            <hr className={"flex-fill track-line"} />
                            :
                            <hr className={item?.approved !== null ? "flex-fill track-line" : "flex-fill track-line-after"} />
                        }

                        {
                          item?.approved === null && item?.cancel_reason !== null ?
                            <div className="d-flex justify-content-center align-items-center"><span className={"big-dot"}></span></div> :
                            <div className="d-flex justify-content-center align-items-center">  <span className={item?.approved !== null ? "big-dot" : "dot"}></span></div>
                        }
                      </div>

                      <div className="d-flex flex-row justify-content-between align-items-center">
                        <p className="w-25" >{handleFormatedDate(item.created)}</p>
                        <p className="w-25 ms-2" >{item.approved != null ? handleFormatedDate(item.approved) : null}</p>
                        <div className="d-flex flex-column">
                          {
                            item?.approved !== null ?
                              <h6 className="fs-6  text-end m-0 ms-1" style={item?.buy_amount !== 0 ? { color: '#FF2C3C' } : { color: '#0A6D26' }}> {item?.buy_amount !== 0 ? `-${item.buy_amount}` : `+${item.sell_amount}`} Amount</h6>
                              :
                              <h6 className="fs-6  text-end ">{""}</h6>
                          }

                          <p className="text-end">{item.approved != null ? handleFormatedDate(item.approved) : item?.approved === null && item?.cancel_reason !== null ? handleFormatedDate(item.modified) : null}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div> :
          <>
            <div className="d-flex  flex-column justify-content-center align-items-center mt-xxl-5 mt-xl-0">
              <img src={noSharesImage} className="w-25" alt="noShares" />
              <div className="text-center my-2">
                <h1 className="fs-5 m-0 my-1" >Currently no shares are available in your account.</h1>
                <p className="m-0">To initiate the purchase of shares.</p>
              </div>

              <div className="align-self-center">
                <button onClick={() => handleClickHere()} variant="contained" className="primaryButton ">
                  Click Here
                </button>
              </div>
            </div>
          </>
      }
      <Modal show={isModalOpen} onHide={handleCloseModal} centered size={"md"} backdrop="static" >
        <Modal.Header style={{ backgroundColor: "#0A2FB6", color: "white" }} data-bs-theme="dark" closeButton>
          <h6 className="text-white fw-bold m-0 montserrat">{"Email Verification"}</h6>
        </Modal.Header>
        <Modal.Body className="text-center p-4 pb-0">
          <h6 className="text-center mx-2">{verificationStatus?.type === 'email' ? OtpSentTextMessageEmail : OtpSentTextMobileNumber} {verificationStatus?.value} </h6>
          {/* <h2 className="fs-5 text-center mx-2"> {modalContent} </h2> */}
          <div className="col-md-12 d-flex flex-column justify-content-center align-items-center my-2 "  >
            <div>
              <OtpInput
                value={otp}
                onChange={setOtp}
                inputType="number"
                numInputs={4}
                renderSeparator={<span className="mx-3"></span>}
                renderInput={(props) => <input {...props} />}
                inputStyle={{
                  width: '46px',
                  height: "40px",
                  borderRadius: "8px",
                  borderStyle: 'solid'

                }}
              />
            </div>
            <div className="align-self-center my-2">
              <p className="m-0">{formatTime(time)}</p>
            </div>
            {
              time === 0 ?
                <div className="mx-4 my-1 align-self-center">
                  <p clas="paraColor Roboto-regular fs-2 m-0" >Didn’t receive code?  <span className="text-primary cursorPointer" onClick={() => handleResend(verificationStatus?.type)}  >Resend</span></p>
                </div> :
                null
            }
            {
              errorMessage != "" ?
                <div className="my-2">
                  <h6 className="text-danger">{errorMessage}</h6>
                </div>
                : null
            }
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-around ">
          <div className="d-flex justify-content-around w-50 mb-1 mt-2">
            <Button onClick={() => handleVerification()} className="logOutButton" disabled={disableButton}>
              {"Verify OTP"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default MyShares